import { render } from "./CrudFiles.vue?vue&type=template&id=191a3b6e"
import script from "./CrudFiles.vue?vue&type=script&lang=js"
export * from "./CrudFiles.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__